import React from 'react';
import { Privilege } from '../../api';
import sessionsService from '../../services/sessions';
import styled from 'styled-components';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import useHasPrivilege from './useHasPrivilege';
import { TSession } from '../Sessions/Sessions';

interface Props {
  session?: TSession | null;
  open: boolean;
  onClose: () => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const DeleteSession: React.FunctionComponent<Props> = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const enabled = useHasPrivilege(Privilege.WriteUsers);
  const onDelete = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (enabled && props.session) {
      sessionsService.deleteSession(props.session.id).then(
        () =>
          enqueueSnackbar('Session has been deleted', {
            variant: 'info',
            autoHideDuration: 3000,
          }),
        () => enqueueSnackbar('Failed to delete session', { variant: 'error', autoHideDuration: 3000 })
      );
    }
    props.onClose();
  };

  const handleClose = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    props.onClose();
  };

  return (
    <Container>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'Delete run?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete this session '{props.session?.homeTeam?.name} - {props.session?.awayTeam?.name}'?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={onDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default DeleteSession;
